if (!customElements.get('product-price-highlight')) {
  customElements.define(
    'product-price-highlight',
    class ProductPriceHighlight extends HTMLElement {
      connectedCallback() {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = event?.data?.sectionId;
          const html = event?.data?.html;
          if (!sectionId || !html) return;

          const source = html.getElementById(`price-${sectionId}`);
          if (source) {
            this.innerHTML = source.innerHTML;
          }
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }
    }
  );
}
